export class Criteo {
	static push(action, data) {
		if (typeof Isell !== "undefined" && Isell.Bus) {
			Isell.Bus.publish(action, data, true);
		}
	}
}
